import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='func getLinkedCardsFor(mobileNumber: String, completion: @escaping (Result<[PrimerNolPaymentCard], PrimerError>) -> Void)' mdxType="Item">
      <p>{`Retrieves a list of linked Nol Pay cards associated with the specified mobile number and phone
country dialing code.`}</p>
      <Group summary='Properties' open mdxType="Group">
  <Item title='mobileNumber' subtitle='String' mdxType="Item">
          <p>{`The mobile number in `}<a parentName="p" {...{
              "href": "https://www.twilio.com/docs/glossary/what-e164"
            }}>{`E.164`}</a>{` format for which linked cards are to be retrieved.`}</p>
  </Item>
  
  <Item title='completion' subtitle='(Result<[PrimerNolPaymentCard], PrimerError>)' mdxType="Item">
          <p>{`Returns Swift.Result containing either a list of linked `}<a parentName="p" {...{
              "href": "/docs/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/nolpay/nolPayPaymentCard"
            }}><inlineCode parentName="a">{`PrimerNolPaymentCard`}</inlineCode></a>{` objects on success or an error on failure.`}</p>
          <p>{`In case of error while fetching the linked cards, as part of the `}<inlineCode parentName="p">{`Result`}</inlineCode>{` object, SDK will return `}<inlineCode parentName="p">{`PrimerError.nolError`}</inlineCode>{`.`}</p>
  </Item>
      </Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      